import { render, staticRenderFns } from "./SelectMailGroup.vue?vue&type=template&id=5023310c&"
import script from "./SelectMailGroup.vue?vue&type=script&lang=js&"
export * from "./SelectMailGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports